import jwtDecode from "jwt-decode";

export function decodeToken(token) {

    const userArray = process.env.REACT_APP_WAB_USER_GROUPS.toString().split(",,,");
    const adminArray = process.env.REACT_APP_WAB_ADMIN_GROUPS.toString().split(",,,");
    let user = false;
    let admin = false;

    const decoded = jwtDecode(token.accessToken);
    let groups = decoded.groups;

    if (!Array.isArray(groups)) {
        groups = Array.of(groups);
    }

    groups.forEach(group => {
        if (adminArray.indexOf(group) > -1) {
            admin = true;
        }
        if (userArray.indexOf(group) > -1) {
            user = true;
        }
    })

    return {
        "user": user,
        "admin": admin,
        "userId": decoded.sub
    }
}
